export enum EarlyPayoutAcceptance {
    Any = 'AcceptAnyChanges',
    Higher = 'AcceptHigherPayoutAmount',
}

export enum AccountMenuVersion {
    V3 = 3,
}
